import { useState, useEffect, useRef } from 'react';
import { Dialog, Card } from '@mui/material';
import { icons } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import Button from '../Buttons/Button';
import { useIsMobile } from '../../helpers/customHooks';
import * as request from "../../services/FetchService";
import { staticSort } from '../../helpers/helperFunctions';
import toast from 'react-hot-toast';
import NewButton from '../Buttons/NewButton';

const NewSupportTicketModal = ({ show, onClose, getTickets }) => {
    const MOBILE = useIsMobile();
    const { t } = useTranslation();
    const [deviceList, setDeviceList] = useState()
    const [selectedDevice, setSelectedDevice] = useState(-1)
    const [message, setMessage] = useState("")
    const [messageSent, setMessageSent] = useState(false)
    const [messageSending, setMessageSending] = useState(false)
    const inputFile = useRef(null);
    const [attachments, setAttachments] = useState([]);

    const handleClose = () => {
        onClose()
    }
    const getDevices = () => {
        if(!show) return;
        request.get("devices/list").then((response) => {
            let sorted = staticSort(response.data?.devices, "name")
            setDeviceList(sorted);
        }); 
    }

    useEffect(() => {
        getDevices()
    }, [show])

    const sendMessage = async () => {
        setMessageSending(true)
        if(!selectedDevice || selectedDevice === -1){
            setMessageSending(false)
            toast.error(t("toast.no_device_selected"))
            return
        }
        if(!message || message === ""){
            setMessageSending(false)
            toast.error(t("toast.no_message"))
            return
        }
        const formData = new FormData();
        formData.append("deviceid", parseInt(selectedDevice));
        formData.append("message", message);
        // Add each file
        attachments.forEach((a) => {
            formData.append("files", a.file, a.name);
        });

        request.postWithFiles("", "account/support/tickets/create", formData).then((response) => {
            if(response.data.successful){
                toast.success(t("toast.sent"))
                onClose()
                setMessageSent(true)
                getTickets()
                setAttachments([])
                setMessageSending(false)
            }
		}); 
    }

    // const sendMessage = async () => {
    //     if(!selectedDevice || selectedDevice === -1){
    //         toast.error(t("toast.no_device_selected"))
    //         return
    //     }
    //     if(!message || message === ""){
    //         toast.error(t("toast.no_message"))
    //         return
    //     }
    //     let data = {
    //         deviceid: parseInt(selectedDevice),
    //         message
    //     }
    //     request.post("", "account/support/tickets/create", data).then((response) => {
    //         if(response.data.successful){
    //             toast.success(t("toast.sent"))
    //             onClose()
    //             setMessageSent(true)
    //             getTickets()
    //         }
	// 	}); 
    // }


      const uploadHandler = () => inputFile.current?.click();

  const handleUploadedFiles = (filesList) => {
    if (!filesList || filesList.length === 0) return;
    const files = Array.from(filesList).map((file) => ({
      id: crypto.randomUUID(),
      name: file.name,
      file,
    }));
    setAttachments((prev) => [...prev, ...files]);

    // allow selecting the same file again later
    if (inputFile.current) inputFile.current.value = "";
  };

  const removeAttachment = (id) =>
    setAttachments((prev) => prev.filter((a) => a.id !== id));

  const clearAll = () => setAttachments([]);
    
    
    return(
        <>
        <Dialog fullWidth={MOBILE ? true : false} open={show} onClose={handleClose}>
            <Card className="settings-dialog d-flex flex-column scrollable-y">
                <div className="w-100 h-100 p-3 grey-blue">
                    <div className="d-flex flex-row justify-content-between align-items-center">
                        <div className='d-flex align-items-center'>
                            {/* <img src={icons.questionmark} alt=""/> */}
                            <h3 className="">{t("settings.new_ticket")}</h3>
                        </div>
                        <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                    </div>
                    <p className="grey-blue py-3">{t("settings.new_ticket_desc")}</p>
                    <div className="d-flex flex-column flex-fill w-100 mb-3">
                        <p className="mb-1 bold">{t("settings.device")}</p>
                        <div className="select-wrap w-100">
                            <select value={selectedDevice} onChange={(e) => setSelectedDevice(e.target.value)} className="bg-light-grey grey-blue form-control text-truncate p-3 rounded24">
                                <option value="">{t("settings.select")}</option>
                                {deviceList?.map((device, index) => {
                                    return(
                                        <option key={index} value={device.id}>{device.name}</option>
                                    )
                                })}
                            </select>
                        </div>
        
                    </div>
                    <div className="mt-3">
                        <p className="mb-1 bold">{t("settings.message")}</p>
                        <NewButton onClick={uploadHandler} icon={icons.plus_circle} iconClass={"grey-blue-icon size_15"} className="bg-grey grey-blue rounded24 p bold">
                            {attachments.length > 0 ? t("settings.add_more") : t("settings.upload_file")}
                        </NewButton>
                        <div className="mt-2">
                            {attachments.length > 0 && (
                                <div className="d-flex flex-wrap">
                                    {attachments.map((a) => (
                                        <div key={a.id} className="d-flex align-items-center justify-content-start px-2 py-1 w-100"
                                        >
                                            <NewButton 
                                                onClick={() => removeAttachment(a.id)}
                                                className="full-rounded bg-red me-2 p-1" 
                                                notext={true} 
                                                icon={icons.close} 
                                                iconClass={"white-icon w-100 h-100 size_12"} />
                                            <p className="grey-blue text-truncate">{a.name}</p>
                                        </div>
                                        ))} 
                                </div>
                            )}
                        </div>
                        <input
                            type="file"
                            id="file"
                            accept="*/*"
                            className="cursor-pointer invisible"
                            onChange={(e) => handleUploadedFiles(e.target.files)}
                            ref={inputFile}
                            style={{ display: "none" }}
                        />
                        <textarea 
                            rows={5}
                            value={message}
                            onChange={(event) => setMessage(event.target.value)} 
                            className="pb-3 form-control text-area-boy bg-light-grey rounded24" />    
                    </div>
                    <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                        <NewButton onClick={() => onClose()} className="bg-grey rounded24 w-100 dark-grey me-2 p-3 body bold">{t("settings.cancel")}</NewButton>
                        <NewButton onClick={() => sendMessage("")} className={`bg-gradient rounded24 w-100 white ms-2 p-3 body bold ${messageSent || messageSending ? "disabled" : ""}`}>{messageSent ? t("settings.sent") : t("settings.send")}</NewButton>
                    </div>
                </div>
            </Card>
        </Dialog>
        </>
    )
}

export default NewSupportTicketModal;